/**
 * Created by Carlos on 11/07/2026.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('promotions', {
                parent: 'app',
                url: '/promotions',
                params: {
                    searchBy: "",
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/message/promotion/promotion.html',
                        controller: 'promotionCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['promotion']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPromotion('promotions')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }]
                        }
                    }
                }
            })
    }
})();
